webpackJsonp([87436308090989],{

/***/ 634:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(20);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(14);
	
	__webpack_require__(13);
	
	var _reactLinkedinInsight = __webpack_require__(17);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	__webpack_require__(35);
	
	__webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/CDPQ_mem1.jpg";
	
	var icon2 = "https://winpeforum.com/assets/elements/AparajitaAhuja.jpeg";
	
	var icon3 = "https://winpeforum.com/assets/elements/MansiAggarwal.png";
	
	var icon4 = "https://winpeforum.com/assets/elements/DianeJegam.jpg";
	
	var icon5 = "https://winpeforum.com/assets/elements/PadmajaRuparel.jpg";
	
	var duration = 400;
	
	var I14 = "https://www.winpeforum.com/assets/sheshines/24jan2024/14.jpg";
	var I15 = "https://www.winpeforum.com/assets/sheshines/24jan2024/15.jpg";
	var I16 = "https://www.winpeforum.com/assets/sheshines/24jan2024/16.jpg";
	var I17 = "https://www.winpeforum.com/assets/sheshines/24jan2024/17.jpg";
	var I18 = "https://www.winpeforum.com/assets/sheshines/24jan2024/18.jpg";
	var I19 = "https://www.winpeforum.com/assets/sheshines/24jan2024/19.jpg";
	
	var II14 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/14.jpg";
	var II15 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/15.jpg";
	var II16 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/16.jpg";
	var II17 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/17.jpg";
	var II18 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/18.jpg";
	var II19 = "https://www.winpeforum.com/download.php?file=assets/sheshines/24jan2024/19.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n            Anita M. George is Executive Vice-President and Deputy Head of CDPQ Global. She fills a key role in developing CDPQ\u2019s activities in its three priority international areas: the United States/Latin America, Europe and Asia Pacific. She actively participates in positioning CDPQ internationally, as well as developing and executing its globalization strategy. In addition to her role managing the international offices, Ms. George contributes to diversifying the portfolio by taking a holistic view in approaching the various markets. She sits on CDPQ\u2019s Investment-Risk Committee.<br/><br/>\n        \n        Ms. George joined CDPQ in April 2016 as Managing Director, South Asia. She was then appointed as Executive Vice-President, Growth Markets and prior to her current role was Executive Vice-President and Head of Strategic Partnerships, Growth Markets. She has extensive knowledge of several of these markets, in addition to possessing a strong ability to develop and strengthen enduring and quality partnerships.<br/><br/>\n        \n        She has a strong track record in managing infrastructure investment portfolios on a global scale. Prior to joining CDPQ, she was Senior Director of the World Bank\u2019s Energy and Extractive Industries Global Practice. She also held the positions of Director, Infrastructure and Natural Resources of the International Finance Corporation, a member of the World Bank Group, and Head of Siemens Financial Services in India. Her various roles have led her to work in several regions of the world, including Europe, Asia, the Middle East, Africa and Latin America.<br/><br/>\n        \n        Ms. George holds a BA in Economics and Spanish from Smith College, in Massachusetts, and a Masters in Economics and an MBA in Finance from Boston University.\n        \n                </div>",
	      name: "Anita George",
	      post: "<div>Co-Founder<br/>\n            Edhina Capital\n            \n            </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n            Aparajita is Partner and CFO at CX Partners, a leading Private Equity group in the Indian mid-market. Currently, she is on the Board of Betterplace. Previously she has served on the boards of DT Group, Veeda Clinical Research and TSI Pvt Ltd. She has been part of the vibrant Private Equity sector since 2008.<br/><br/>\n        \n            She is a qualified Chartered Accountant and holds an undergraduate degree in Commerce from the University of Delhi.\n            \n        \n        \n            </div>",
	      name: "Aparajita Ahuja",
	      post: "<div>Partner & CFO<br/>CX Partners\n        \n        \n            </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n            Diane Jegam is the Regional Director of Proparco South Asia, covering the origination of both debt and equity investments in the region. Since joining French Development Agency in 2008, Diane held different positions within the group with a focus in Africa and has worked in numerous impactful sectors.\n            <br/><br/>\n        Before this posting in India, she held the position of Deputy Director of the French Development Agency (AFD) in Dakar (2017 \u2013 2021), one of the important office of AFD Group network.\n        \n        \n        \n            </div>",
	      name: "Diane Jegam",
	      post: "<div>Regional Director South Asia\t<br/>\n            Proparco\n            \n            \n            </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n            Mansi Aggarwal is a Partner at Alkemi Growth Capital. She has build and invest in leading and sustainable healthcare and consumer companies in India, with a portfolio of over 10 (and counting!) innovative and disruptive startups. With over 15+ years of experience as an investor, banker, and entrepreneur, she has a deep understanding of the opportunities and challenges in these sectors, and a passion for creating positive social impact.\n    <br/><Br/>\n    Her journey as a business leader began with her education in dental surgery and MBA, followed by involvement in the Stanford Biodesign program, where she co-founded and exited a medical device startup. She also hold 6 patents in healthcare and biotechnology and has been recognized for her achievements in Indian and global forums. She leverages her diverse background, skills, and network to support the growth and success of the companies she invest in and partner with.\n      \n            \n            </div>",
	      name: "Mansi Aggarwal",
	      post: "<div>Partner\n    <br/>\n            Alkemi Growth Capital\n            \n      \n      \n            </div>"
	    }, {
	      imgUrl: icon5,
	      desc: "<div>\n            Padmaja Ruparel is nationally recognized as a key player in the Indian entrepreneurial ecosystem and has helped co-found many of the relevant institutions, besides being an active Angel investor herself. Her operating experience spans large corporates, M&A, and startups/early stage companies. \n            <br/><br/>\n        She has been awarded as one of the 'Top 50 Most Powerful Women in Business' by Fortune India for 2017, 2018 2019, listed in Forbes India's WPower Trailblazers and \u201C30 Most Powerful Women in India\u201D by Business Today for 3 years running. The Women Economic Forum recognized her with its \u201CWomen of the Decade in Investment Banking\u201D award. \n        <br/><br/>\n        She is Co-Founder & President of Indian Angel Network (IAN), India's first and now possibly one of the world's largest group of business angels, comprising the who's who of successful entrepreneurs and dynamic CEOs from India and overseas. She built IAN from inception, making it within 15 years a unique institution globally, with close to 500 investors across 10 countries and a portfolio of 175+ companies in 7 countries, spanning 17 sectors. She has operationalised IAN's international operations in London - making it the only angel group in the world to set up operations outside of its home country. Padmaja has been nominated as Co Chair of Global Business Angel Network (GBAN). She is a member of the National Expert Advisory Committee on Innovation, Incubation and Technology Entrepreneurship. She is a member of several committees of BIRAC (Dept. of Biotech, Govt. of India), various committees of the Ministry of Finance, DPIIT, & SEBI. \n        <br/><br/>\n        Padmaja is the Senior Managing Partner of the IAN Fund, a uniquely differentiated Fund which along with IAN, is set to create the largest horizontal platform in India for investing in seed and early stage ventures. \n        <br/><br/>\n        She is a member of the Governing Council of EM3 Services, a nation building venture seeking to create a paradigm shift in the Indian agricultural sector by improving productivity. Padmaja is an Independent Director on the Boards of Avendus Finance Pvt. Ltd. & Ester Industries Ltd. \n        <br/><br/>\n        Apart from cofounding IAN, she also set up and operationalised the Delhi chapter of The Indus Entrepreneurs (TIE) the world's largest organization focused on entrepreneurship with over 16,000 members across more than 60 chapters across 14 countries. She also established a unique model of an incubator, in partnership with the Indian Government, leveraging 400 mentors to provide mentoring & domain expertise to around 50 young fledgling incubated companies. She played a key role as Executive Director in building the Indian Venture Capital Association, India's oldest and largest association of VC and PE firms. Currently, she is a member of IVCA's Limited Partners Council. \n        <br/><br/>\n        She helped the creation of the Lankan Angel Network in Sri Lanka. She contributed actively in the Planning Commission's Committee on \u201CAngel & Early Stage Investing in India\u201D which resulted in a seminal report: \u201CCreating a Vibrant Entrepreneurial Ecosystem in India\u201D.\n        <br/><br/>\n        In her corporate avatar at Xansa India, (Xansa was a US$800mn company listed on LSE before being acquired by Steria), she led several functions over a 16 year period : handled recruitment operations, built and successfully executed an innovative brand and communication strategy and led the corporate social responsibility initiative which engaged employees, clients as also the government. She was a key member of the corporate strategy and M&A team as the Company went public, forged joint ventures and the final acquisition of the Indian company. \n        <br/><br/>\n        Padmaja picked up entrepreneurial strings very early in her career - she revived and grew the family real estate business in Calcutta - growing from 50,000 sq ft to over 250,000 sq ft over 2 years and turned it around to become a profitable business. \n        <br/><br/>\n        A graduate with English Honours, Padmaja then completed her MBA as well as Chartered Accountancy (Intermediate) with her internship with S.R. Batliboi (an E&Y group company).\n        \n        \n        \n            </div>",
	      name: "Padmaja Ruparel",
	      post: "<div>Co-Founder & President<br/>\n            Indian Angel Network\n            \n            \n            </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 45, ImgSrc: I14, ImgSrc1: II14 }, { id: 19, ImgSrc: I15, ImgSrc1: II15 }, { id: 49, ImgSrc: I16, ImgSrc1: II16 }, { id: 21, ImgSrc: I17, ImgSrc1: II17 }, { id: 20, ImgSrc: I18, ImgSrc1: II18 }, { id: 14, ImgSrc: I19, ImgSrc1: II19 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Women on Boards",
	        image: "https://winpeforum.com/assets/wob/banner.jpg",
	        description: "Winpe\u2019s Women on Boards initiative partners with progressive companies to build stronger, more diverse boardrooms by increasing the representation of highly qualified, board-ready women leaders. The initiative provides access to a curated pool of exceptional candidates, board-readiness resources, and engagement models that align with companies\u2019 governance goals and DEI commitments.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper", style: { paddingTop: '110px', minHeight: 'auto' } },
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "a",
	              { href: "https://tally.so/r/wv9OJX" },
	              "   ",
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/banner1.jpg", alt: "About Image", style: { width: '100%' } })
	            )
	          ),
	          " "
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', height: 'auto', width: '100%', backgroundSize: 'cover' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#ffffff', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '600', fontFamily: 'Lato' } },
	              "About WOB "
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "sub__body__text", style: { textAlign: 'center', color: '#ffffff', fontSize: '17px' } },
	              " Winpe is a leading platform committed to advancing gender diversity and leadership representation in the investing ecosystem. Winpe collaborates closely with Private Equity and Venture Capital firms, as well as broader industry stakeholders, to foster a more inclusive and equitable environment for women professionals across levels and functions.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Winpe\u2019s Women on Boards initiative partners with progressive PEVC firms and companies to build stronger, more diverse boardrooms by increasing the representation of highly qualified, experienced women leaders. The initiative provides access to a curated pool of exceptional candidates, boardroom excellence resources, and builds a strong peer community of women on boards.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "For queries, Please reach out to us on wob@winpeforum.com."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg2.png)', height: 'auto', width: '100%', backgroundSize: 'cover' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#22316b', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '600', fontFamily: 'Lato' } },
	                "18% "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "sub__body__text", style: { textAlign: 'center', color: '#000', fontSize: '17px' } },
	                " Women on Indian Boards (2022)"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#bf2026', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '600', fontFamily: 'Lato' } },
	                "600+ "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "sub__body__text", style: { textAlign: 'center', color: '#000', fontSize: '17px' } },
	                " Companies with only 1 Woman Director"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-4" },
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#22316b', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '600', fontFamily: 'Lato' } },
	                "1% "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "sub__body__text", style: { textAlign: 'center', color: '#000', fontSize: '17px' } },
	                " Growth in 3 years"
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "sub__body__text", style: { textAlign: 'center', color: '#000', fontSize: '9px', fontWeight: '500' } },
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "  ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "*EY Report- ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://www.ey.com/en_in/women-fast-forward/accelerate-dei-in-the-boardrooms-to-create-long-term-value-and-sustainability" },
	                "https://www.ey.com/en_in/women-fast-forward/accelerate-dei-in-the-boardrooms-to-create-long-term-value-and-sustainability"
	              ),
	              "  ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h1",
	              { style: { color: '#22316B', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '700', fontFamily: 'Lato' } },
	              "Impact of Gender Diverse Boards on Business Performance"
	            ),
	            _react2.default.createElement(
	              "marquee",
	              { style: { fontSize: '17px' } },
	              _react2.default.createElement(
	                "b",
	                null,
	                "Profit Margins:"
	              ),
	              " Firms with greater gender diversity in leadership reported up to 30% higher profit margins and nearly 30% higher cumulative ROE over five years.\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Share Price Performance:"
	              ),
	              " Companies with more than 50% female executives and directors averaged a 3-year annualized share price return of 13.46%, compared to 4.78% for less diverse companies.\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "RoA:"
	              ),
	              " A 2020 study of S&P 500 boards conducted over eleven years found a positive link between higher gender diversity and increased return on assets.\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Revenue Growth:"
	              ),
	              " S&P 500 companies with more than 30% female board representation outperformed those with less than 20% in year-over-year revenue growth, across 11 of the top 15 industries.\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Fund Returns and Profitable Exits (Venture Capital):"
	              ),
	              " A 10% increase in female partner hires led to a 1.5% annual increase in fund returns and 9.7% more profitable exits in venture capital firms. "
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg3.png)', height: 'auto', minHeight: '540px', width: '100%', backgroundSize: 'cover', paddingBottom: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#22316b', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '700', fontFamily: 'Lato' } },
	              "Our Approach"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-4 col-lg-4" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "box", style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', color: '#fff', width: '95%', padding: '25px 10px 20px 20px', minHeight: '200px', textAlign: 'center' } },
	                  _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/1.png", style: { width: '60px' } }),
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Ecosystem Building"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Access to board roles/ candidates, sessions on board excellence, regular knowledge updates and in-person networking with experts and peers"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-4 col-lg-4" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "box", style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', color: '#fff', width: '95%', padding: '20px 10px 20px 20px', minHeight: '200px', textAlign: 'center' } },
	                  _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/2.png", style: { width: '70px' } }),
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Industry Buy-In"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Support from top tier PEVC firms keen to add expertise and diverse perspectives to the boards of their investee companies"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-4 col-lg-4" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "box", style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', color: '#fff', width: '95%', padding: '25px 10px 20px 20px', minHeight: '240px', textAlign: 'center' } },
	                  _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/3.png", style: { width: '50px' } }),
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Expertise Led "
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Curated database of senior women professionals with deep experience and expertise across sectors and functions"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { "class": "col-md-12" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-2 col-lg-2" },
	                "\xA0"
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-4 col-lg-4" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "box", style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', color: '#fff', width: '95%', padding: '25px 10px 20px 20px', minHeight: '230px', textAlign: 'center' } },
	                  _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/4.png", style: { width: '60px' } }),
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Pre-screening for fit"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "All profiles screened and catalogued based on a wide number of technical criteria to support best matching "
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-sm-6 col-md-4 col-lg-4" },
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "div",
	                  { className: "box", style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg.jpg)', color: '#fff', width: '95%', padding: '25px 10px 20px 20px', minHeight: '230px', textAlign: 'center' } },
	                  _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/5.png", style: { width: '60px' } }),
	                  _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Complete Confidentiality"
	                  ),
	                  _react2.default.createElement(
	                    "p",
	                    null,
	                    "Strict confidentiality and anonymity of the companies and profiles in the database, unless waived"
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg4.png)', height: 'auto', minHeight: '540px', width: '100%', backgroundSize: 'cover', paddingBottom: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "col-sm-12 col-md-12 col-lg-12" },
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#fff', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '700', fontFamily: 'Lato' } },
	                "Board Excellence Session"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "center",
	                null,
	                _react2.default.createElement("img", { src: "https://winpeforum.com/assets/wob/board1.png" })
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "sub__body__text", style: { textAlign: 'center', color: '#fff', fontSize: '17px' } },
	                "Led by M. Damodaran, former Chairman of SEBI, UTI, and IDBI Bank along with board veterans, the Board Excellence session has been developed to elevate boardroom impact through India's most respected corporate governance expertise",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "Designed keeping in mind both first time directors and experienced directors, whether serving as independent directors, nominee directors or executive directors, the session uses a real-life lens to decode board room dynamics and functioning"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://forms.gle/Ugbg86k3zU3r84rr6" },
	                  "  ",
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/31july.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                "  "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBBoardroomSimulation" },
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/25june2.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                "    "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/b1.png", alt: "About Image", style: { width: '100%' } })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBShareholderMisalignment" },
	                  "  ",
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/a1new1.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                "  "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBTheDPDPAct/" },
	                  "  ",
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/c1.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                "    "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBSelf-Led-Series-Session1/" },
	                  "  ",
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/d1.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                "    "
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBModule2EventReport/" },
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/e1.png", alt: "About Image", style: { width: '100%' } })
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-lg-4 col-md-4 col-sm-12", style: { margin: 0, padding: 0 } },
	                _react2.default.createElement(
	                  "a",
	                  { href: "https://winpeforum.com/WOBModule1EventReport/" },
	                  "   ",
	                  _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/mod/f1.png", alt: "About Image", style: { width: '100%' } })
	                ),
	                " "
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { backgroundImage: 'url(https://winpeforum.com/assets/wob/bg2.png)', height: 'auto', minHeight: '540px', width: '100%', backgroundSize: 'cover', paddingBottom: '45px', paddingTop: '45px' } },
	          _react2.default.createElement(
	            "div",
	            { className: "container" },
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h1",
	              { className: " title", style: { color: '#22316b', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '700', fontFamily: 'Lato' } },
	              "Distinguished Board of Advisors"
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-3 col-md-3 col-sm-12" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/4.png", alt: "About Image", style: { width: '100%' } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-3 col-md-3 col-sm-12" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/1.png", alt: "About Image", style: { width: '100%' } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-3 col-md-3 col-sm-12" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/2.png", alt: "About Image", style: { width: '100%' } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-3 col-md-3 col-sm-12" },
	              _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/3.png", alt: "About Image", style: { width: '100%' } })
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-12" },
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h1",
	                { className: " title", style: { color: '#22316b', textAlign: 'center', marginTop: '0px', paddingLeft: '15px', fontWeight: '700', fontFamily: 'Lato' } },
	                "Expert Screening Committee"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "center",
	                null,
	                " ",
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/5.png", alt: "About Image", style: { width: '75%' } }),
	                " "
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "center",
	                null,
	                "   ",
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/6.png", alt: "About Image", style: { width: '75%' } }),
	                " "
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-lg-4 col-md-4 col-sm-12" },
	              _react2.default.createElement(
	                "center",
	                null,
	                "  ",
	                _react2.default.createElement("img", { className: "main-img-1", src: "https://winpeforum.com/assets/wob/speaker/7.png", alt: "About Image", style: { width: '75%' } }),
	                " "
	              )
	            )
	          )
	        ),
	        _react2.default.createElement("br", null),
	        " ",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("div", null)
	      ),
	      _react2.default.createElement(TeamModal, {
	        show: isShow,
	        onHide: this.togglePopUp,
	        activeItem: this.state.activeItem
	      })
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-womenonboards-index-js-a5c5ae3ccc460ff45477.js